import Dialog from "@mui/material/Dialog";
import MuiDialogActions from "@mui/material/DialogActions";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogTitle from "@mui/material/DialogTitle";
import { withStyles } from "@mui/styles";
import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress/CircularProgress";
import "./PromptModal.scss";

export interface IPromptModalProps {
  title?: string;
  confirmText?: string;
  rejectText?: string;
  open: boolean;
  onReject?: () => void;
  onConfirm?: () => void;
  confirmDisabled?: boolean;
  isLoading?: boolean;

  confirmText2?: string;
  onConfirm2?: () => void;
  confirmDisabled2?: boolean;
  width?: string;
  bgColor?: string;
}

const DialogTitle = withStyles(() => ({
  root: {
    marginTop: "32px",
    textTransform: "uppercase",
    color: "#D85D0F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "120%",
  },
}))(MuiDialogTitle);

const DialogContent = withStyles((theme) => ({
  root: {
    "& p": {
      fontSize: "1rem",
      lineHeight: "2",
      marginBottom: 0,
      color: theme.palette.text.primary,
    },
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    marginBottom: "0",
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "row",
  },
}))(MuiDialogActions);

class PromptModal<T> extends React.Component<IPromptModalProps & { onConfirm?: (T) => void }> {
  constructor(props: IPromptModalProps) {
    super(props);
  }

  handleClickOpen = () => {};

  handleConfirm = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    const { onConfirm } = this.props;
    this.setState({ open: false });

    if (onConfirm) {
      onConfirm();
    }
  };

  handleConfirm2 = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    const { onConfirm2 } = this.props;
    this.setState({ open: false });

    if (onConfirm2) {
      onConfirm2();
    }
  };

  handleReject = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    const { onReject } = this.props;
    this.setState({ open: false });

    if (onReject) {
      onReject();
    }
  };

  render() {
    const {
      children,
      title,
      confirmText,
      rejectText,
      open,
      confirmDisabled,
      isLoading,
      confirmText2,
      confirmDisabled2,
    } = this.props;
    return (
      <div>
        <Dialog
          open={open}
          onClose={this.handleReject}
          className="prompt-modal-v2"
          maxWidth="lg"
          PaperProps={{
            style: {
              width: this.props.width || "80rem",
              maxWidth: "auto",
              padding: "16px",
              background: this.props.bgColor || "#fff",
            },
          }}>
          {title && (
            <DialogTitle className="title">
              {title}
              {isLoading && <CircularProgress size="16px" sx={{ marginLeft: "1rem" }} />}
            </DialogTitle>
          )}

          <DialogContent>{children}</DialogContent>

          <DialogActions>
            {rejectText && (
              <button
                className="button-v2 button-v2__secondary"
                onClick={this.handleReject}
                autoFocus>
                {rejectText}
              </button>
            )}
            {confirmText && (
              <button
                className="button-v2 button-v2__primary"
                onClick={this.handleConfirm}
                disabled={confirmDisabled}>
                {confirmText}
              </button>
            )}
            {confirmText2 && (
              <button
                className="button-v2 button-v2__primary"
                onClick={this.handleConfirm2}
                disabled={confirmDisabled2}>
                {confirmText2}
              </button>
            )}
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default PromptModal;
